import script from "./joinUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./joinUpload.vue?vue&type=script&setup=true&lang=js"

import "./joinUpload.vue?vue&type=style&index=0&id=6e76e128&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e76e128"]])

export default __exports__